module.exports = __webpack_public_path__ + "static/media/infiniti-vial.a4226a10.svg";